import React, { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext(null);

export const CURRENCIES = {
  usd: { code: "usd", symbol: "$", label: "USD" },
  gbp: { code: "gbp", symbol: "£", label: "GBP" },
};

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("soiree_currency") : null;
    return stored && CURRENCIES[stored] ? stored : "usd";
  });
  useEffect(() => {
    try { localStorage.setItem("soiree_currency", currency); } catch {}
  }, [currency]);
  const setCurrency = (c) => { if (CURRENCIES[c]) setCurrencyState(c); };
  const symbol = CURRENCIES[currency].symbol;
  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, symbol, info: CURRENCIES[currency] }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
